// import React, { useState, useEffect } from 'react';
// import './ProfilePage.css';
// import { useTranslation } from 'react-i18next';

// const API_URL = 'http://localhost:3001/api';
// // const API_URL = 'http://185.188.182.203:3001/api';

// const ProfilePage = ({ user, onBack, onLogout, onLogin }) => {
//   const { t } = useTranslation();
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [showAuthModal, setShowAuthModal] = useState(true);
//   const [isLoginMode, setIsLoginMode] = useState(true);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [showConsentModal, setShowConsentModal] = useState(null);
  
//   const [loginForm, setLoginForm] = useState({ email: '', password: '' });
//   const [registerForm, setRegisterForm] = useState({ 
//     email: '', 
//     firstName: '', 
//     lastName: '', 
//     phone: '',
//     password: '',
//     consents: {
//       personalData: false,
//       medicalIntervention: false,
//       telemedicine: false
//     }
//   });
//   const [editForm, setEditForm] = useState({ firstName: '', lastName: '', phone: '' });
//   const [loginError, setLoginError] = useState('');
  
//   const [activeTab, setActiveTab] = useState('overview');
//   const [healthHistory, setHealthHistory] = useState([]);
//   const [documents, setDocuments] = useState([]);
//   const [testResults, setTestResults] = useState([]);
//   const [consents, setConsents] = useState([]);
//   const [settings, setSettings] = useState({ push_notifications: 1 });

//   const consentTexts = {
//     personalData: `СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ...`,
//     medicalIntervention: `ДОБРОВОЛЬНОЕ ИНФОРМИРОВАННОЕ СОГЛАСИЕ НА МЕДИЦИНСКОЕ ВМЕШАТЕЛЬСТВО...`,
//     telemedicine: `СОГЛАСИЕ НА ТЕЛЕМЕДИЦИНСКИЕ КОНСУЛЬТАЦИИ...`
//   };

//   const availableConsents = [
//     { id: 'personalData', name: 'Согласие на обработку персональных данных', required: true },
//     { id: 'medicalIntervention', name: 'Согласие на медицинское вмешательство', required: true },
//     { id: 'telemedicine', name: 'Согласие на телемедицинские консультации', required: false }
//   ];

//   const getFileUrl = (filePath) => {
//     if (!filePath) return '';
//     if (filePath.startsWith('http')) return filePath;
//     const baseUrl = API_URL.replace('/api', '');
//     return `${baseUrl}${filePath}`;
//   };

//   useEffect(() => {
//     const token = localStorage.getItem('authToken');
//     const savedUser = localStorage.getItem('currentUser');
    
//     if (token && savedUser) {
//       const userData = JSON.parse(savedUser);
//       setCurrentUser(userData);
//       setIsAuthenticated(true);
//       setShowAuthModal(false);
//       fetchUserData(userData.id);
//     }
//   }, []);

//   const fetchUserData = async (userId) => {
//     setLoading(true);
//     try {
//       const userResponse = await fetch(`${API_URL}/users/${userId}`);
//       if (userResponse.ok) {
//         const userData = await userResponse.json();
//         setCurrentUser(prev => ({ ...prev, ...userData }));
//         setEditForm({
//           firstName: userData.firstName,
//           lastName: userData.lastName,
//           phone: userData.phone || ''
//         });
//       }
      
//       const docsResponse = await fetch(`${API_URL}/users/${userId}/documents`);
//       if (docsResponse.ok) {
//         const docsData = await docsResponse.json();
//         setDocuments(docsData);
//       }
      
//       const testResultsResponse = await fetch(`${API_URL}/doctor/patient/${userId}/history`);
//       if (testResultsResponse.ok) {
//         const historyData = await testResultsResponse.json();
//         setTestResults(historyData.testResults || []);
//       }
      
//       const consentsResponse = await fetch(`${API_URL}/users/${userId}/consents`);
//       if (consentsResponse.ok) {
//         const consentsData = await consentsResponse.json();
//         setConsents(consentsData);
//       }
      
//       const healthResponse = await fetch(`${API_URL}/users/${userId}/health-metrics`);
//       if (healthResponse.ok) {
//         const healthData = await healthResponse.json();
//         const formattedHistory = healthData.map(item => ({
//           id: item.id,
//           date: item.measured_at?.split('-').reverse().join('.') || '',
//           systolic: item.systolic,
//           diastolic: item.diastolic,
//           pulse: item.pulse,
//           temperature: item.temperature,
//           glucose: item.glucose,
//           notes: item.notes
//         }));
//         setHealthHistory(formattedHistory);
//       }
      
//       const settingsResponse = await fetch(`${API_URL}/users/${userId}/settings`);
//       if (settingsResponse.ok) {
//         const settingsData = await settingsResponse.json();
//         setSettings({ push_notifications: settingsData.push_notifications === 1 ? true : false });
//       }
//     } catch (error) {
//       console.error('Ошибка загрузки данных пользователя:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpdateProfile = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_URL}/users/${currentUser.id}`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           firstName: editForm.firstName,
//           lastName: editForm.lastName,
//           phone: editForm.phone
//         })
//       });
      
//       if (response.ok) {
//         setCurrentUser(prev => ({ 
//           ...prev, 
//           firstName: editForm.firstName, 
//           lastName: editForm.lastName,
//           phone: editForm.phone
//         }));
//         setIsEditing(false);
        
//         const updatedUser = { ...currentUser, firstName: editForm.firstName, lastName: editForm.lastName, phone: editForm.phone };
//         localStorage.setItem('currentUser', JSON.stringify(updatedUser));
//       } else {
//         const error = await response.json();
//         console.error('Ошибка обновления:', error);
//       }
//     } catch (error) {
//       console.error('Ошибка обновления профиля:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogin = async () => {
//     if (!loginForm.email || !loginForm.password) {
//       setLoginError('Заполните все поля');
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const response = await fetch(`${API_URL}/users/login`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: loginForm.email,
//           password: loginForm.password
//         })
//       });
      
//       const data = await response.json();
      
//       if (response.ok && data.success) {
//         const userData = data.user;
//         setCurrentUser(userData);
//         setIsAuthenticated(true);
//         setShowAuthModal(false);
//         setLoginError('');
//         localStorage.setItem('authToken', 'logged_in');
//         localStorage.setItem('currentUser', JSON.stringify(userData));
//         if (onLogin) onLogin(userData);
//         await fetchUserData(userData.id);
//       } else {
//         setLoginError(data.error || 'Неверный email или пароль');
//       }
//     } catch (error) {
//       console.error('Ошибка входа:', error);
//       setLoginError('Ошибка подключения к серверу');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleConsentChange = (consentId) => {
//     setRegisterForm({
//       ...registerForm,
//       consents: {
//         ...registerForm.consents,
//         [consentId]: !registerForm.consents[consentId]
//       }
//     });
//   };

//   const areRequiredConsentsAccepted = () => {
//     const requiredConsents = availableConsents.filter(c => c.required);
//     return requiredConsents.every(consent => registerForm.consents[consent.id]);
//   };

//   const handleRegister = async () => {
//     if (!registerForm.email || !registerForm.firstName || !registerForm.lastName || !registerForm.password) {
//       setLoginError('Заполните все поля');
//       return;
//     }
    
//     if (registerForm.password.length < 6) {
//       setLoginError('Пароль должен быть не менее 6 символов');
//       return;
//     }
    
//     if (!areRequiredConsentsAccepted()) {
//       setLoginError('Пожалуйста, примите обязательные согласия');
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const selectedConsents = [];
//       for (const [key, value] of Object.entries(registerForm.consents)) {
//         if (value) {
//           const consent = availableConsents.find(c => c.id === key);
//           if (consent) {
//             selectedConsents.push(consent.name);
//           }
//         }
//       }
      
//       const response = await fetch(`${API_URL}/users/register`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: registerForm.email,
//           firstName: registerForm.firstName,
//           lastName: registerForm.lastName,
//           phone: registerForm.phone,
//           password: registerForm.password,
//           consents: selectedConsents
//         })
//       });
      
//       const data = await response.json();
      
//       if (response.ok) {
//         const loginResponse = await fetch(`${API_URL}/users/login`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             email: registerForm.email,
//             password: registerForm.password
//           })
//         });
        
//         const loginData = await loginResponse.json();
        
//         if (loginResponse.ok && loginData.success) {
//           const userData = loginData.user;
//           setCurrentUser(userData);
//           setIsAuthenticated(true);
//           setShowAuthModal(false);
//           setLoginError('');
//           localStorage.setItem('authToken', 'logged_in');
//           localStorage.setItem('currentUser', JSON.stringify(userData));
//           if (onLogin) onLogin(userData);
//           await fetchUserData(userData.id);
//         }
//       } else {
//         setLoginError(data.error || 'Ошибка регистрации');
//       }
//     } catch (error) {
//       console.error('Ошибка регистрации:', error);
//       setLoginError('Ошибка подключения к серверу');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('authToken');
//     localStorage.removeItem('currentUser');
//     setIsAuthenticated(false);
//     setShowAuthModal(true);
//     setCurrentUser(null);
//     setLoginForm({ email: '', password: '' });
//     setRegisterForm({ 
//       email: '', firstName: '', lastName: '', phone: '', password: '',
//       consents: { personalData: false, medicalIntervention: false, telemedicine: false }
//     });
//     setHealthHistory([]);
//     setDocuments([]);
//     setTestResults([]);
//     setConsents([]);
//     if (onLogout) onLogout();
//   };

//   const updatePushNotification = async (checked) => {
//     const newValue = checked ? 1 : 0;
//     setSettings({ push_notifications: checked });
    
//     try {
//       await fetch(`${API_URL}/users/${currentUser?.id}/settings`, {
//         method: 'PUT',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ push_notifications: newValue })
//       });
//     } catch (error) {
//       console.error('Ошибка обновления настроек:', error);
//       setSettings({ push_notifications: !checked });
//     }
//   };

//   const formatDate = (dateStr) => {
//     if (!dateStr) return '';
//     const date = new Date(dateStr);
//     return date.toLocaleDateString('ru-RU');
//   };

//   const ConsentModal = ({ consentId, consentName, onClose }) => {
//     const consentText = consentTexts[consentId] || 'Текст согласия не найден';
    
//     return (
//       <div className="modal-overlay" onClick={onClose}>
//         <div className="consent-modal" onClick={(e) => e.stopPropagation()}>
//           <div className="consent-modal-header">
//             <h3>{consentName}</h3>
//             <button className="modal-close-btn" onClick={onClose}>×</button>
//           </div>
//           <div className="consent-modal-body">
//             <pre className="consent-text-pre">{consentText}</pre>
//           </div>
//           <div className="consent-modal-footer">
//             <button className="consent-close-btn" onClick={onClose}>Закрыть</button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (showAuthModal) {
//     return (
//       <div className="profile-page">
//         <div className="profile-header">
//           <button className="back-btn-full" onClick={onBack}>
//             <span className="btn-icon">←</span>
//             <span className="btn-text">{t('Назад')}</span>
//           </button>
//         </div>
        
//         <div className="auth-container">
//           <div className="auth-card">
//             <div className="auth-icon">👤</div>
//             <h2>{isLoginMode ? 'Вход в профиль' : 'Регистрация'}</h2>
            
//             {isLoginMode ? (
//               <div className="auth-form">
//                 <input
//                   type="email"
//                   className="auth-input"
//                   placeholder="Email"
//                   value={loginForm.email}
//                   onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
//                   disabled={loading}
//                 />
//                 <input
//                   type="password"
//                   className="auth-input"
//                   placeholder="Пароль"
//                   value={loginForm.password}
//                   onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
//                   disabled={loading}
//                 />
//                 {loginError && <div className="auth-error">{loginError}</div>}
//                 <button className="auth-btn" onClick={handleLogin} disabled={loading}>
//                   {loading ? 'Загрузка...' : 'Войти'}
//                 </button>
//                 <p className="auth-switch">
//                   Нет аккаунта?{' '}
//                   <span onClick={() => { setIsLoginMode(false); setLoginError(''); }}>
//                     Зарегистрироваться
//                   </span>
//                 </p>
//               </div>
//             ) : (
//               <div className="auth-form">
//                 <input
//                   type="email"
//                   className="auth-input"
//                   placeholder="Email"
//                   value={registerForm.email}
//                   onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
//                   disabled={loading}
//                 />
//                 <input
//                   type="text"
//                   className="auth-input"
//                   placeholder="Имя"
//                   value={registerForm.firstName}
//                   onChange={(e) => setRegisterForm({ ...registerForm, firstName: e.target.value })}
//                   disabled={loading}
//                 />
//                 <input
//                   type="text"
//                   className="auth-input"
//                   placeholder="Фамилия"
//                   value={registerForm.lastName}
//                   onChange={(e) => setRegisterForm({ ...registerForm, lastName: e.target.value })}
//                   disabled={loading}
//                 />
//                 <input
//                   type="tel"
//                   className="auth-input"
//                   placeholder="Телефон (необязательно)"
//                   value={registerForm.phone}
//                   onChange={(e) => setRegisterForm({ ...registerForm, phone: e.target.value })}
//                   disabled={loading}
//                 />
//                 <input
//                   type="password"
//                   className="auth-input"
//                   placeholder="Пароль (мин. 6 символов)"
//                   value={registerForm.password}
//                   onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
//                   disabled={loading}
//                 />
                
//                 <div className="consents-section">
//                   <div className="consents-title">Пожалуйста, ознакомьтесь с соглашениями:</div>
//                   {availableConsents.map(consent => (
//                     <div key={consent.id} className="consent-card">
//                       <div className="consent-card-header">
//                         <label className="consent-checkbox">
//                           <input
//                             type="checkbox"
//                             checked={registerForm.consents[consent.id]}
//                             onChange={() => handleConsentChange(consent.id)}
//                             disabled={loading}
//                           />
//                           <span className="checkmark"></span>
//                           <span className="consent-name">
//                             {consent.name}
//                             {consent.required && <span className="required-badge">Обязательно</span>}
//                           </span>
//                         </label>
//                         <button 
//                           type="button"
//                           className="view-consent-btn-card"
//                           onClick={() => setShowConsentModal(consent)}
//                         >
//                           📄 Просмотреть
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
                
//                 {loginError && <div className="auth-error">{loginError}</div>}
//                 <button 
//                   className="auth-btn" 
//                   onClick={handleRegister} 
//                   disabled={loading || !areRequiredConsentsAccepted()}
//                 >
//                   {loading ? 'Загрузка...' : 'Зарегистрироваться'}
//                 </button>
//                 <p className="auth-switch">
//                   Уже есть аккаунт?{' '}
//                   <span onClick={() => { setIsLoginMode(true); setLoginError(''); }}>
//                     Войти
//                   </span>
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
        
//         {showConsentModal && (
//           <ConsentModal 
//             consentId={showConsentModal.id}
//             consentName={showConsentModal.name}
//             onClose={() => setShowConsentModal(null)}
//           />
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="profile-page">
//       <div className="profile-header">
//         <button className="back-btn-full" onClick={onBack}>
//           <span className="btn-icon">←</span>
//           <span className="btn-text">{t('Назад')}</span>
//         </button>
//       </div>

//       <div className="profile-tabs">
//         <button 
//           className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
//           onClick={() => setActiveTab('overview')}
//         >
//           📊 Обзор
//         </button>
//         <button 
//           className={`tab-btn ${activeTab === 'test-results' ? 'active' : ''}`}
//           onClick={() => setActiveTab('test-results')}
//         >
//           🔬 Результаты анализов ({testResults.length})
//         </button>
//         <button 
//           className={`tab-btn ${activeTab === 'documents' ? 'active' : ''}`}
//           onClick={() => setActiveTab('documents')}
//         >
//           📄 Документы ({documents.length})
//         </button>
//         <button 
//           className={`tab-btn ${activeTab === 'settings' ? 'active' : ''}`}
//           onClick={() => setActiveTab('settings')}
//         >
//           ⚙️ Настройки
//         </button>
//       </div>

//       <div className="profile-content">
//         {loading ? (
//           <div className="loading-spinner">Загрузка...</div>
//         ) : (
//           <>
//             {activeTab === 'overview' && (
//               <>
//                 <div className="patient-card">
//                   <div className="profile-avatar">
//                     <div className="avatar-placeholder">
//                       {currentUser?.firstName?.[0] || '👤'}
//                     </div>
//                   </div>
//                   <div className="patient-info" style={{ flex: 1 }}>
//                     {isEditing ? (
//                       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                         <input
//                           type="text"
//                           className="auth-input"
//                           style={{ padding: '8px', fontSize: '14px' }}
//                           value={editForm.firstName}
//                           onChange={(e) => setEditForm({ ...editForm, firstName: e.target.value })}
//                           placeholder="Имя"
//                         />
//                         <input
//                           type="text"
//                           className="auth-input"
//                           style={{ padding: '8px', fontSize: '14px' }}
//                           value={editForm.lastName}
//                           onChange={(e) => setEditForm({ ...editForm, lastName: e.target.value })}
//                           placeholder="Фамилия"
//                         />
//                         <input
//                           type="tel"
//                           className="auth-input"
//                           style={{ padding: '8px', fontSize: '14px' }}
//                           value={editForm.phone}
//                           onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
//                           placeholder="Телефон"
//                         />
//                         <div style={{ display: 'flex', gap: '8px', marginTop: '5px' }}>
//                           <button 
//                             className="save-btn" 
//                             onClick={handleUpdateProfile}
//                             style={{ padding: '8px', fontSize: '13px', flex: 1 }}
//                           >
//                             💾 Сохранить
//                           </button>
//                           <button 
//                             className="cancel-btn" 
//                             onClick={() => {
//                               setIsEditing(false);
//                               setEditForm({
//                                 firstName: currentUser?.firstName || '',
//                                 lastName: currentUser?.lastName || '',
//                                 phone: currentUser?.phone || ''
//                               });
//                             }}
//                             style={{ padding: '8px', fontSize: '13px', flex: 1 }}
//                           >
//                             ❌ Отмена
//                           </button>
//                         </div>
//                       </div>
//                     ) : (
//                       <>
//                         <h3>{currentUser?.firstName} {currentUser?.lastName}</h3>
//                         <p className="patient-id">Email: {currentUser?.email}</p>
//                         {currentUser?.phone && <p className="patient-snils">📞 {currentUser?.phone}</p>}
//                         <p className="patient-snils">ID: {currentUser?.id}</p>
//                         <button 
//                           className="update-health-btn"
//                           onClick={() => setIsEditing(true)}
//                           style={{ marginTop: '10px', background: 'rgba(52,152,219,0.3)' }}
//                         >
//                           ✏️ Редактировать профиль
//                         </button>
//                       </>
//                     )}
//                   </div>
//                 </div>

//                 <div className="recent-documents">
//                   <h3 className="section-title">📋 Последние документы</h3>
//                   {documents.length > 0 ? (
//                     documents.slice(0, 3).map(doc => (
//                       <div key={doc.id} className="document-item">
//                         <span className="doc-icon">📄</span>
//                         <div className="doc-info">
//                           <div className="doc-name">{doc.type}</div>
//                           <div className="doc-date">{formatDate(doc.created_at)}</div>
//                           <div className="doc-doctor">{doc.doctor || 'Врач'}</div>
//                         </div>
//                         {doc.file_url && (
//                           <button className="doc-view-btn" onClick={() => window.open(getFileUrl(doc.file_url), '_blank')}>
//                             Открыть
//                           </button>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <div className="no-data">У вас пока нет документов</div>
//                   )}
//                 </div>

//                 {testResults.length > 0 && (
//                   <div className="recent-documents">
//                     <h3 className="section-title">🔬 Последние результаты анализов</h3>
//                     {testResults.slice(0, 3).map(result => (
//                       <div key={result.id} className="document-item">
//                         <span className="doc-icon">🔬</span>
//                         <div className="doc-info">
//                           <div className="doc-name">{result.title}</div>
//                           <div className="doc-date">{formatDate(result.created_at)}</div>
//                           {result.description && <div className="doc-doctor">{result.description.substring(0, 50)}...</div>}
//                         </div>
//                         {result.file_url && (
//                           <button className="doc-view-btn" onClick={() => window.open(getFileUrl(result.file_url), '_blank')}>
//                             Открыть
//                           </button>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {healthHistory.length > 0 && (
//                   <div className="recent-documents">
//                     <h3 className="section-title">📊 Последние показатели здоровья</h3>
//                     {healthHistory.slice(0, 3).map(metric => (
//                       <div key={metric.id} className="document-item">
//                         <span className="doc-icon">❤️</span>
//                         <div className="doc-info">
//                           <div className="doc-name">Давление: {metric.systolic}/{metric.diastolic} | Пульс: {metric.pulse}</div>
//                           <div className="doc-date">{metric.date}</div>
//                           {metric.notes && <div className="doc-doctor">{metric.notes}</div>}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </>
//             )}

//             {activeTab === 'test-results' && (
//               <div className="documents-list">
//                 <h3 className="section-title" style={{ marginBottom: '15px' }}>🔬 Все результаты анализов</h3>
//                 {testResults.length > 0 ? (
//                   testResults.map(result => (
//                     <div key={result.id} className="document-card">
//                       <div className="doc-type-icon">🔬</div>
//                       <div className="doc-content">
//                         <div className="doc-title">{result.title}</div>
//                         {result.description && <div className="doc-meta">Описание: {result.description}</div>}
//                         <div className="doc-meta">Добавлено: {formatDate(result.created_at)}</div>
//                       </div>
//                       {result.file_url && (
//                         <button 
//                           className="download-btn" 
//                           onClick={() => window.open(getFileUrl(result.file_url), '_blank')}
//                         >
//                           📥 Скачать
//                         </button>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className="no-data">У вас пока нет результатов анализов</div>
//                 )}
//               </div>
//             )}

//             {activeTab === 'documents' && (
//               <div className="documents-list">
//                 <h3 className="section-title" style={{ marginBottom: '15px' }}>📄 Все документы</h3>
//                 {documents.length > 0 ? (
//                   documents.map(doc => (
//                     <div key={doc.id} className="document-card">
//                       <div className="doc-type-icon">📄</div>
//                       <div className="doc-content">
//                         <div className="doc-title">{doc.type}</div>
//                         <div className="doc-meta">
//                           Врач: {doc.doctor || '—'} | {formatDate(doc.created_at)}
//                         </div>
//                       </div>
//                       {doc.file_url && (
//                         <button 
//                           className="download-btn" 
//                           onClick={() => window.open(getFileUrl(doc.file_url), '_blank')}
//                         >
//                           📥 Открыть
//                         </button>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className="no-data">У вас пока нет документов</div>
//                 )}
//               </div>
//             )}

//             {activeTab === 'settings' && (
//               <>
//                 <div className="settings-section">
//                   <h3 className="section-title">🔐 Настройки</h3>

//                   <div className="setting-item">
//                     <div className="setting-info">
//                       <span className="setting-icon">📱</span>
//                       <div>
//                         <div className="setting-title">Push-уведомления</div>
//                         <div className="setting-desc">Получать уведомления о результатах анализов</div>
//                       </div>
//                     </div>
//                     <label className="switch">
//                       <input 
//                         type="checkbox" 
//                         checked={settings.push_notifications === true}
//                         onChange={(e) => updatePushNotification(e.target.checked)}
//                       />
//                       <span className="slider round"></span>
//                     </label>
//                   </div>
//                 </div>

//                 <div className="settings-section">
//                   <h3 className="section-title">📜 Мои согласия</h3>
//                   {consents.length > 0 ? (
//                     consents.map(consent => (
//                       <div key={consent.id} className="consent-item">
//                         <div className="consent-info">
//                           <span className="consent-icon">✅</span>
//                           <span className="consent-text">{consent.type}</span>
//                           <span className="consent-date">Подписано: {formatDate(consent.signed_at)}</span>
//                         </div>
//                         <button 
//                           className="view-consent-btn"
//                           onClick={() => {
//                             const consentId = consent.type.includes('Персональных') ? 'personalData' :
//                                             consent.type.includes('медицинское') ? 'medicalIntervention' : 'telemedicine';
//                             setShowConsentModal({
//                               id: consentId,
//                               name: consent.type
//                             });
//                           }}
//                         >
//                           📄 Просмотреть
//                         </button>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="no-data">Нет подписанных согласий</div>
//                   )}
//                 </div>

//                 <div className="settings-section">
//                   <h3 className="section-title">👤 Управление аккаунтом</h3>
//                   <button className="logout-btn" onClick={handleLogout}>
//                     <span className="btn-icon">🚪</span>
//                     <span className="btn-text">Выйти</span>
//                   </button>
//                 </div>
//               </>
//             )}
//           </>
//         )}
//       </div>
      
//       {showConsentModal && (
//         <ConsentModal 
//           consentId={showConsentModal.id}
//           consentName={showConsentModal.name}
//           onClose={() => setShowConsentModal(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default ProfilePage;




import React, { useState, useEffect } from 'react';
import './ProfilePage.css';
import { useTranslation } from 'react-i18next';

// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru/api';

const ProfilePage = ({ user, onBack, onLogout, onLogin, onOpenStaff, onOpenDoctor }) => {
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(true);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showConsentModal, setShowConsentModal] = useState(null);
  
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [registerForm, setRegisterForm] = useState({ 
    email: '', 
    firstName: '', 
    lastName: '', 
    phone: '',
    password: '',
    consents: {
      personalData: false,
      medicalIntervention: false,
      telemedicine: false
    }
  });
  const [editForm, setEditForm] = useState({ firstName: '', lastName: '', phone: '' });
  const [loginError, setLoginError] = useState('');
  
  const [activeTab, setActiveTab] = useState('overview');
  const [healthHistory, setHealthHistory] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [testResults, setTestResults] = useState([]);
  const [consents, setConsents] = useState([]);
  const [settings, setSettings] = useState({ push_notifications: 1 });

  const consentTexts = {
    personalData: `СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ...`,
    medicalIntervention: `ДОБРОВОЛЬНОЕ ИНФОРМИРОВАННОЕ СОГЛАСИЕ НА МЕДИЦИНСКОЕ ВМЕШАТЕЛЬСТВО...`,
    telemedicine: `СОГЛАСИЕ НА ТЕЛЕМЕДИЦИНСКИЕ КОНСУЛЬТАЦИИ...`
  };

  const availableConsents = [
    { id: 'personalData', name: 'Согласие на обработку персональных данных', required: true },
    { id: 'medicalIntervention', name: 'Согласие на медицинское вмешательство', required: true },
    { id: 'telemedicine', name: 'Согласие на телемедицинские консультации', required: false }
  ];

  const getFileUrl = (filePath) => {
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = API_URL.replace('/api', '');
    return `${baseUrl}${filePath}`;
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('currentUser');
    
    if (token && savedUser) {
      const userData = JSON.parse(savedUser);
      setCurrentUser(userData);
      setIsAuthenticated(true);
      setShowAuthModal(false);
      fetchUserData(userData.id);
    }
  }, []);

  const fetchUserData = async (userId) => {
    setLoading(true);
    try {
      const userResponse = await fetch(`${API_URL}/users/${userId}`);
      if (userResponse.ok) {
        const userData = await userResponse.json();
        setCurrentUser(prev => ({ ...prev, ...userData }));
        setEditForm({
          firstName: userData.firstName,
          lastName: userData.lastName,
          phone: userData.phone || ''
        });
      }
      
      const docsResponse = await fetch(`${API_URL}/users/${userId}/documents`);
      if (docsResponse.ok) {
        const docsData = await docsResponse.json();
        setDocuments(docsData);
      }
      
      const testResultsResponse = await fetch(`${API_URL}/doctor/patient/${userId}/history`);
      if (testResultsResponse.ok) {
        const historyData = await testResultsResponse.json();
        setTestResults(historyData.testResults || []);
      }
      
      const consentsResponse = await fetch(`${API_URL}/users/${userId}/consents`);
      if (consentsResponse.ok) {
        const consentsData = await consentsResponse.json();
        setConsents(consentsData);
      }
      
      const healthResponse = await fetch(`${API_URL}/users/${userId}/health-metrics`);
      if (healthResponse.ok) {
        const healthData = await healthResponse.json();
        const formattedHistory = healthData.map(item => ({
          id: item.id,
          date: item.measured_at?.split('-').reverse().join('.') || '',
          systolic: item.systolic,
          diastolic: item.diastolic,
          pulse: item.pulse,
          temperature: item.temperature,
          glucose: item.glucose,
          notes: item.notes
        }));
        setHealthHistory(formattedHistory);
      }
      
      const settingsResponse = await fetch(`${API_URL}/users/${userId}/settings`);
      if (settingsResponse.ok) {
        const settingsData = await settingsResponse.json();
        setSettings({ push_notifications: settingsData.push_notifications === 1 ? true : false });
      }
    } catch (error) {
      console.error('Ошибка загрузки данных пользователя:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateProfile = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/users/${currentUser.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: editForm.firstName,
          lastName: editForm.lastName,
          phone: editForm.phone
        })
      });
      
      if (response.ok) {
        setCurrentUser(prev => ({ 
          ...prev, 
          firstName: editForm.firstName, 
          lastName: editForm.lastName,
          phone: editForm.phone
        }));
        setIsEditing(false);
        
        const updatedUser = { ...currentUser, firstName: editForm.firstName, lastName: editForm.lastName, phone: editForm.phone };
        localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      } else {
        const error = await response.json();
        console.error('Ошибка обновления:', error);
      }
    } catch (error) {
      console.error('Ошибка обновления профиля:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!loginForm.email || !loginForm.password) {
      setLoginError('Заполните все поля');
      return;
    }
    
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: loginForm.email,
          password: loginForm.password
        })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        const userData = data.user;
        setCurrentUser(userData);
        setIsAuthenticated(true);
        setShowAuthModal(false);
        setLoginError('');
        localStorage.setItem('authToken', 'logged_in');
        localStorage.setItem('currentUser', JSON.stringify(userData));
        if (onLogin) onLogin(userData);
        await fetchUserData(userData.id);
      } else {
        setLoginError(data.error || 'Неверный email или пароль');
      }
    } catch (error) {
      console.error('Ошибка входа:', error);
      setLoginError('Ошибка подключения к серверу');
    } finally {
      setLoading(false);
    }
  };

  const handleConsentChange = (consentId) => {
    setRegisterForm({
      ...registerForm,
      consents: {
        ...registerForm.consents,
        [consentId]: !registerForm.consents[consentId]
      }
    });
  };

  const areRequiredConsentsAccepted = () => {
    const requiredConsents = availableConsents.filter(c => c.required);
    return requiredConsents.every(consent => registerForm.consents[consent.id]);
  };

  const handleRegister = async () => {
    if (!registerForm.email || !registerForm.firstName || !registerForm.lastName || !registerForm.password) {
      setLoginError('Заполните все поля');
      return;
    }
    
    if (registerForm.password.length < 6) {
      setLoginError('Пароль должен быть не менее 6 символов');
      return;
    }
    
    if (!areRequiredConsentsAccepted()) {
      setLoginError('Пожалуйста, примите обязательные согласия');
      return;
    }
    
    setLoading(true);
    try {
      const selectedConsents = [];
      for (const [key, value] of Object.entries(registerForm.consents)) {
        if (value) {
          const consent = availableConsents.find(c => c.id === key);
          if (consent) {
            selectedConsents.push(consent.name);
          }
        }
      }
      
      const response = await fetch(`${API_URL}/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: registerForm.email,
          firstName: registerForm.firstName,
          lastName: registerForm.lastName,
          phone: registerForm.phone,
          password: registerForm.password,
          consents: selectedConsents
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        const loginResponse = await fetch(`${API_URL}/users/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: registerForm.email,
            password: registerForm.password
          })
        });
        
        const loginData = await loginResponse.json();
        
        if (loginResponse.ok && loginData.success) {
          const userData = loginData.user;
          setCurrentUser(userData);
          setIsAuthenticated(true);
          setShowAuthModal(false);
          setLoginError('');
          localStorage.setItem('authToken', 'logged_in');
          localStorage.setItem('currentUser', JSON.stringify(userData));
          if (onLogin) onLogin(userData);
          await fetchUserData(userData.id);
        }
      } else {
        setLoginError(data.error || 'Ошибка регистрации');
      }
    } catch (error) {
      console.error('Ошибка регистрации:', error);
      setLoginError('Ошибка подключения к серверу');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');
    setIsAuthenticated(false);
    setShowAuthModal(true);
    setCurrentUser(null);
    setLoginForm({ email: '', password: '' });
    setRegisterForm({ 
      email: '', firstName: '', lastName: '', phone: '', password: '',
      consents: { personalData: false, medicalIntervention: false, telemedicine: false }
    });
    setHealthHistory([]);
    setDocuments([]);
    setTestResults([]);
    setConsents([]);
    if (onLogout) onLogout();
  };

  const updatePushNotification = async (checked) => {
    const newValue = checked ? 1 : 0;
    setSettings({ push_notifications: checked });
    
    try {
      await fetch(`${API_URL}/users/${currentUser?.id}/settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ push_notifications: newValue })
      });
    } catch (error) {
      console.error('Ошибка обновления настроек:', error);
      setSettings({ push_notifications: !checked });
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ru-RU');
  };

  const ConsentModal = ({ consentId, consentName, onClose }) => {
    const consentText = consentTexts[consentId] || 'Текст согласия не найден';
    
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="consent-modal" onClick={(e) => e.stopPropagation()}>
          <div className="consent-modal-header">
            <h3>{consentName}</h3>
            <button className="modal-close-btn" onClick={onClose}>×</button>
          </div>
          <div className="consent-modal-body">
            <pre className="consent-text-pre">{consentText}</pre>
          </div>
          <div className="consent-modal-footer">
            <button className="consent-close-btn" onClick={onClose}>Закрыть</button>
          </div>
        </div>
      </div>
    );
  };

  if (showAuthModal) {
    return (
      <div className="profile-page">
        <div className="profile-header">
          <button className="back-btn-full" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('Назад')}</span>
          </button>
        </div>
        
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-icon">👤</div>
            <h2>{isLoginMode ? 'Вход в профиль' : 'Регистрация'}</h2>
            
            {isLoginMode ? (
              <div className="auth-form">
                <input
                  type="email"
                  className="auth-input"
                  placeholder="Email"
                  value={loginForm.email}
                  onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                  disabled={loading}
                />
                <input
                  type="password"
                  className="auth-input"
                  placeholder="Пароль"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  disabled={loading}
                />
                {loginError && <div className="auth-error">{loginError}</div>}
                <button className="auth-btn" onClick={handleLogin} disabled={loading}>
                  {loading ? 'Загрузка...' : 'Войти'}
                </button>
                
                {/* Разветвление: кнопки для входа персонала и врача */}
                <div className="auth-divider">
                  <span>или</span>
                </div>
                <div className="auth-role-buttons">
                  <button 
                    className="auth-role-btn staff"
                    onClick={() => onOpenStaff && onOpenStaff()}
                  >
                    👥 Вход для персонала
                  </button>
                  <button 
                    className="auth-role-btn doctor"
                    onClick={() => onOpenDoctor && onOpenDoctor()}
                  >
                    👨‍⚕️ Вход для врачей
                  </button>
                </div>
                
                <p className="auth-switch">
                  Нет аккаунта?{' '}
                  <span onClick={() => { setIsLoginMode(false); setLoginError(''); }}>
                    Зарегистрироваться
                  </span>
                </p>
              </div>
            ) : (
              <div className="auth-form">
                <input
                  type="email"
                  className="auth-input"
                  placeholder="Email"
                  value={registerForm.email}
                  onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
                  disabled={loading}
                />
                <input
                  type="text"
                  className="auth-input"
                  placeholder="Имя"
                  value={registerForm.firstName}
                  onChange={(e) => setRegisterForm({ ...registerForm, firstName: e.target.value })}
                  disabled={loading}
                />
                <input
                  type="text"
                  className="auth-input"
                  placeholder="Фамилия"
                  value={registerForm.lastName}
                  onChange={(e) => setRegisterForm({ ...registerForm, lastName: e.target.value })}
                  disabled={loading}
                />
                <input
                  type="tel"
                  className="auth-input"
                  placeholder="Телефон (необязательно)"
                  value={registerForm.phone}
                  onChange={(e) => setRegisterForm({ ...registerForm, phone: e.target.value })}
                  disabled={loading}
                />
                <input
                  type="password"
                  className="auth-input"
                  placeholder="Пароль (мин. 6 символов)"
                  value={registerForm.password}
                  onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
                  disabled={loading}
                />
                
                <div className="consents-section">
                  <div className="consents-title">Пожалуйста, ознакомьтесь с соглашениями:</div>
                  {availableConsents.map(consent => (
                    <div key={consent.id} className="consent-card">
                      <div className="consent-card-header">
                        <label className="consent-checkbox">
                          <input
                            type="checkbox"
                            checked={registerForm.consents[consent.id]}
                            onChange={() => handleConsentChange(consent.id)}
                            disabled={loading}
                          />
                          <span className="checkmark"></span>
                          <span className="consent-name">
                            {consent.name}
                            {consent.required && <span className="required-badge">Обязательно</span>}
                          </span>
                        </label>
                        <button 
                          type="button"
                          className="view-consent-btn-card"
                          onClick={() => setShowConsentModal(consent)}
                        >
                          📄 Просмотреть
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                
                {loginError && <div className="auth-error">{loginError}</div>}
                <button 
                  className="auth-btn" 
                  onClick={handleRegister} 
                  disabled={loading || !areRequiredConsentsAccepted()}
                >
                  {loading ? 'Загрузка...' : 'Зарегистрироваться'}
                </button>
                
                <p className="auth-switch">
                  Уже есть аккаунт?{' '}
                  <span onClick={() => { setIsLoginMode(true); setLoginError(''); }}>
                    Войти
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
        
        {showConsentModal && (
          <ConsentModal 
            consentId={showConsentModal.id}
            consentName={showConsentModal.name}
            onClose={() => setShowConsentModal(null)}
          />
        )}
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="profile-header">
        <button className="back-btn-full" onClick={onBack}>
          <span className="btn-icon">←</span>
          <span className="btn-text">{t('Назад')}</span>
        </button>
      </div>

      <div className="profile-tabs">
        <button 
          className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          📊 Обзор
        </button>
        <button 
          className={`tab-btn ${activeTab === 'test-results' ? 'active' : ''}`}
          onClick={() => setActiveTab('test-results')}
        >
          🔬 Результаты анализов ({testResults.length})
        </button>
        <button 
          className={`tab-btn ${activeTab === 'documents' ? 'active' : ''}`}
          onClick={() => setActiveTab('documents')}
        >
          📄 Документы ({documents.length})
        </button>
        <button 
          className={`tab-btn ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          ⚙️ Настройки
        </button>
      </div>

      <div className="profile-content">
        {loading ? (
          <div className="loading-spinner">Загрузка...</div>
        ) : (
          <>
            {activeTab === 'overview' && (
              <>
                <div className="patient-card">
                  <div className="profile-avatar">
                    <div className="avatar-placeholder">
                      {currentUser?.firstName?.[0] || '👤'}
                    </div>
                  </div>
                  <div className="patient-info" style={{ flex: 1 }}>
                    {isEditing ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <input
                          type="text"
                          className="auth-input"
                          style={{ padding: '8px', fontSize: '14px' }}
                          value={editForm.firstName}
                          onChange={(e) => setEditForm({ ...editForm, firstName: e.target.value })}
                          placeholder="Имя"
                        />
                        <input
                          type="text"
                          className="auth-input"
                          style={{ padding: '8px', fontSize: '14px' }}
                          value={editForm.lastName}
                          onChange={(e) => setEditForm({ ...editForm, lastName: e.target.value })}
                          placeholder="Фамилия"
                        />
                        <input
                          type="tel"
                          className="auth-input"
                          style={{ padding: '8px', fontSize: '14px' }}
                          value={editForm.phone}
                          onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                          placeholder="Телефон"
                        />
                        <div style={{ display: 'flex', gap: '8px', marginTop: '5px' }}>
                          <button 
                            className="save-btn" 
                            onClick={handleUpdateProfile}
                            style={{ padding: '8px', fontSize: '13px', flex: 1 }}
                          >
                            💾 Сохранить
                          </button>
                          <button 
                            className="cancel-btn" 
                            onClick={() => {
                              setIsEditing(false);
                              setEditForm({
                                firstName: currentUser?.firstName || '',
                                lastName: currentUser?.lastName || '',
                                phone: currentUser?.phone || ''
                              });
                            }}
                            style={{ padding: '8px', fontSize: '13px', flex: 1 }}
                          >
                            ❌ Отмена
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <h3>{currentUser?.firstName} {currentUser?.lastName}</h3>
                        <p className="patient-id">Email: {currentUser?.email}</p>
                        {currentUser?.phone && <p className="patient-snils">📞 {currentUser?.phone}</p>}
                        <p className="patient-snils">ID: {currentUser?.id}</p>
                        <button 
                          className="update-health-btn"
                          onClick={() => setIsEditing(true)}
                          style={{ marginTop: '10px', background: 'rgba(52,152,219,0.3)' }}
                        >
                          ✏️ Редактировать профиль
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div className="recent-documents">
                  <h3 className="section-title">📋 Последние документы</h3>
                  {documents.length > 0 ? (
                    documents.slice(0, 3).map(doc => (
                      <div key={doc.id} className="document-item">
                        <span className="doc-icon">📄</span>
                        <div className="doc-info">
                          <div className="doc-name">{doc.type}</div>
                          <div className="doc-date">{formatDate(doc.created_at)}</div>
                          <div className="doc-doctor">{doc.doctor || 'Врач'}</div>
                        </div>
                        {doc.file_url && (
                          <button className="doc-view-btn" onClick={() => window.open(getFileUrl(doc.file_url), '_blank')}>
                            Открыть
                          </button>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="no-data">У вас пока нет документов</div>
                  )}
                </div>

                {testResults.length > 0 && (
                  <div className="recent-documents">
                    <h3 className="section-title">🔬 Последние результаты анализов</h3>
                    {testResults.slice(0, 3).map(result => (
                      <div key={result.id} className="document-item">
                        <span className="doc-icon">🔬</span>
                        <div className="doc-info">
                          <div className="doc-name">{result.title}</div>
                          <div className="doc-date">{formatDate(result.created_at)}</div>
                          {result.description && <div className="doc-doctor">{result.description.substring(0, 50)}...</div>}
                        </div>
                        {result.file_url && (
                          <button className="doc-view-btn" onClick={() => window.open(getFileUrl(result.file_url), '_blank')}>
                            Открыть
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {healthHistory.length > 0 && (
                  <div className="recent-documents">
                    <h3 className="section-title">📊 Последние показатели здоровья</h3>
                    {healthHistory.slice(0, 3).map(metric => (
                      <div key={metric.id} className="document-item">
                        <span className="doc-icon">❤️</span>
                        <div className="doc-info">
                          <div className="doc-name">Давление: {metric.systolic}/{metric.diastolic} | Пульс: {metric.pulse}</div>
                          <div className="doc-date">{metric.date}</div>
                          {metric.notes && <div className="doc-doctor">{metric.notes}</div>}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {activeTab === 'test-results' && (
              <div className="documents-list">
                <h3 className="section-title" style={{ marginBottom: '15px' }}>🔬 Все результаты анализов</h3>
                {testResults.length > 0 ? (
                  testResults.map(result => (
                    <div key={result.id} className="document-card">
                      <div className="doc-type-icon">🔬</div>
                      <div className="doc-content">
                        <div className="doc-title">{result.title}</div>
                        {result.description && <div className="doc-meta">Описание: {result.description}</div>}
                        <div className="doc-meta">Добавлено: {formatDate(result.created_at)}</div>
                      </div>
                      {result.file_url && (
                        <button 
                          className="download-btn" 
                          onClick={() => window.open(getFileUrl(result.file_url), '_blank')}
                        >
                          📥 Скачать
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="no-data">У вас пока нет результатов анализов</div>
                )}
              </div>
            )}

            {activeTab === 'documents' && (
              <div className="documents-list">
                <h3 className="section-title" style={{ marginBottom: '15px' }}>📄 Все документы</h3>
                {documents.length > 0 ? (
                  documents.map(doc => (
                    <div key={doc.id} className="document-card">
                      <div className="doc-type-icon">📄</div>
                      <div className="doc-content">
                        <div className="doc-title">{doc.type}</div>
                        <div className="doc-meta">
                          Врач: {doc.doctor || '—'} | {formatDate(doc.created_at)}
                        </div>
                      </div>
                      {doc.file_url && (
                        <button 
                          className="download-btn" 
                          onClick={() => window.open(getFileUrl(doc.file_url), '_blank')}
                        >
                          📥 Открыть
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="no-data">У вас пока нет документов</div>
                )}
              </div>
            )}

            {activeTab === 'settings' && (
              <>
                <div className="settings-section">
                  <h3 className="section-title">🔐 Настройки</h3>

                  <div className="setting-item">
                    <div className="setting-info">
                      <span className="setting-icon">📱</span>
                      <div>
                        <div className="setting-title">Push-уведомления</div>
                        <div className="setting-desc">Получать уведомления о результатах анализов</div>
                      </div>
                    </div>
                    <label className="switch">
                      <input 
                        type="checkbox" 
                        checked={settings.push_notifications === true}
                        onChange={(e) => updatePushNotification(e.target.checked)}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>

                <div className="settings-section">
                  <h3 className="section-title">📜 Мои согласия</h3>
                  {consents.length > 0 ? (
                    consents.map(consent => (
                      <div key={consent.id} className="consent-item">
                        <div className="consent-info">
                          <span className="consent-icon">✅</span>
                          <span className="consent-text">{consent.type}</span>
                          <span className="consent-date">Подписано: {formatDate(consent.signed_at)}</span>
                        </div>
                        <button 
                          className="view-consent-btn"
                          onClick={() => {
                            const consentId = consent.type.includes('Персональных') ? 'personalData' :
                                            consent.type.includes('медицинское') ? 'medicalIntervention' : 'telemedicine';
                            setShowConsentModal({
                              id: consentId,
                              name: consent.type
                            });
                          }}
                        >
                          📄 Просмотреть
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="no-data">Нет подписанных согласий</div>
                  )}
                </div>

                <div className="settings-section">
                  <h3 className="section-title">👤 Управление аккаунтом</h3>
                  <button className="logout-btn" onClick={handleLogout}>
                    <span className="btn-icon">🚪</span>
                    <span className="btn-text">Выйти</span>
                  </button>
                </div>
              </>
            )}
          </>
        )}
      </div>
      
      {showConsentModal && (
        <ConsentModal 
          consentId={showConsentModal.id}
          consentName={showConsentModal.name}
          onClose={() => setShowConsentModal(null)}
        />
      )}
    </div>
  );
};

export default ProfilePage;